import { useState } from 'react';
import { useQuery } from '@apollo/client';
import * as R from 'ramda';

import { GET_USER } from '@atom/graph/user';
import { useNavigation } from '@atom/hooks/useNavigation';
import { Progress } from '@atom/mui';

import BudgetsTab from './budgetsTab/BudgetsTab';
import CertificationsTab from './certificationsTab/CertificationsTab';
import UserHeader from './header/UserHeader';
import InfoTab from './infoTab/InfoTab';
import PermissionsTab from './permissionsTab/PermissionsTab';
import RolesTab from './rolesTab/RolesTab';
import SettingsTab from './settingsTab/SettingsTab';
import WorkTab from './workTab/WorkTab';
import UserContext, { View } from './UserContext';

import classes from './userDetail.module.css';

const UserDetail = () => {
  const [activeView, setActiveView] = useState<View>(View.INFO);
  const [, { params }] = useNavigation();
  const { id } = params;

  const { loading, data, error, refetch } = useQuery(GET_USER, {
    variables: {
      id,
    },
    fetchPolicy: 'network-only',
  });

  if (error || R.isNil(data)) {
    return <Progress style={{ height: '100%' }} />;
  }

  const getActiveView = () => {
    const views = {
      [View.INFO]: <InfoTab />,
      [View.BUDGETS]: <BudgetsTab />,
      [View.PERMISSIONS]: <PermissionsTab />,
      [View.CERTIFICATIONS]: <CertificationsTab />,
      [View.WORK]: <WorkTab />,
      [View.SETTINGS]: <SettingsTab />,
      [View.ROLES]: <RolesTab />,
    };

    return views[activeView];
  };

  const contextValue = {
    activeView,
    setActiveView,
    user: data ? data.user : {},
    loading,
    refetch,
  };

  return (
    <UserContext.Provider value={contextValue}>
      <div className={classes.userDetailContainer}>
        <UserHeader />
        <div className={classes.contentContainer}>
          {activeView === View.INFO || activeView === View.WORK ? (
            <div className={classes.fullPaneContainer}>{getActiveView()}</div>
          ) : (
            <div className={classes.centerPaneContainer}>
              <div className={classes.centerPane} style={{ overflow: 'auto' }}>
                {getActiveView()}
              </div>
            </div>
          )}
        </div>
      </div>
    </UserContext.Provider>
  );
};

export default UserDetail;
